import { useEffect } from "react";
import dayjs from "dayjs";
import { useGlobal } from "@/migrated-widgets/table-map/contexts/GlobalState";
import { useAudienceVisitorsTableMapState } from "../AudienceVisitorsTableMapState";
import { useTableMapExport, useWidgetData } from "@/app/widgets/WidgetFactoryContext";

const useExportAudienceMap = () => {
    const { zipCodes, makeIds, modelIds, groupIds, vehicleTypes } = useAudienceVisitorsTableMapState();
    const { params } = useGlobal();
    const { fetchWidgetExportData } = useWidgetData();
    const { registerExportHandler, unregisterExportHandler } = useTableMapExport();

    useEffect(() => {
        const widgetId = params.widgetId;
        if (!widgetId) return;

        const exportHandler = () => {
            fetchWidgetExportData({
                ...params,
                zipCodes,
                vehicleTypes,
                makeIds,
                modelIds,
                groupIds,
                dateRange: {
                    from: dayjs(params.startDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                    to: dayjs(params.endDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                },
            } as any);
        };

        registerExportHandler(widgetId, exportHandler);

        return () => {
            unregisterExportHandler(widgetId, exportHandler);
        };
    }, [params.widgetId, params, zipCodes, makeIds, modelIds, groupIds, vehicleTypes, registerExportHandler, unregisterExportHandler]);
};

export default useExportAudienceMap;
